class CinematicFooter extends HTMLElement {
  constructor() {
    super();
    this.wrapper = this.querySelector('.cinematic-footer-outer-wrapper');
    this.giantText = this.querySelector('.cinematic-footer-giant-text');
    this.unifiedCard = this.querySelector('.unified-footer-inner');
    this.magneticButtons = this.querySelectorAll('.magnetic-button');
    this.gsapRetries = 0;

    // Parallax markup only exists in the cinematic (index) variant.
    if (this.wrapper) this.initGSAP();

    // Magnetic effect is mouse-only; GSAP is not loaded on touch devices.
    if (this.magneticButtons.length && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      this.initMagneticButtons();
    }
  }

  initGSAP() {
    // Wait (bounded) for GSAP + ScrollTrigger to be available
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
      if (++this.gsapRetries < 50) setTimeout(() => this.initGSAP(), 100);
      return;
    }
    
    gsap.registerPlugin(ScrollTrigger);

    // Background Parallax
    if (this.giantText && this.wrapper) {
      gsap.fromTo(
        this.giantText,
        { y: "10vh", scale: 0.8, opacity: 0 },
        {
          y: "0vh",
          scale: 1,
          opacity: 1,
          ease: "power1.out",
          scrollTrigger: {
            trigger: this.wrapper,
            start: "top 80%",
            end: "bottom bottom",
            scrub: 1,
          },
        }
      );
    }

    // Unified Card Reveal
    if (this.unifiedCard && this.wrapper) {
      gsap.fromTo(
        this.unifiedCard,
        { y: 50, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          ease: "power3.out",
          scrollTrigger: {
            trigger: this.wrapper,
            start: "top 40%",
            end: "bottom bottom",
            scrub: 1,
          },
        }
      );
    }
  }

  initMagneticButtons() {
    if (typeof gsap === 'undefined') {
      setTimeout(() => this.initMagneticButtons(), 100);
      return;
    }

    this.magneticButtons.forEach(btn => {
      btn.addEventListener('mousemove', (e) => {
        const rect = btn.getBoundingClientRect();
        const h = rect.width / 2;
        const w = rect.height / 2;
        const x = e.clientX - rect.left - h;
        const y = e.clientY - rect.top - w;

        gsap.to(btn, {
          x: x * 0.4,
          y: y * 0.4,
          rotationX: -y * 0.15,
          rotationY: x * 0.15,
          scale: 1.05,
          ease: "power2.out",
          duration: 0.4,
        });
      });

      btn.addEventListener('mouseleave', () => {
        gsap.to(btn, {
          x: 0,
          y: 0,
          rotationX: 0,
          rotationY: 0,
          scale: 1,
          ease: "elastic.out(1, 0.3)",
          duration: 1.2,
        });
      });
    });
  }
}

if (!customElements.get('cinematic-footer')) {
  customElements.define('cinematic-footer', CinematicFooter);
}
